import { Shuffle } from "lucide-react";

import InputField from "@components/fields/input-field";
import LoadingButton from "@components/ui-components/loading-button";
import Modal from "@components/ui-components/modal";
import SelectField from "@components/fields/select-field";
import { CURRENCY_OPTIONS } from "../misc/constants";

const InvoiceCreateModal = ({ modal, brand, methods, loading, onClose, onSubmit, onRegenerateIds }) => {
    const { control, formState: { errors } } = methods;
    const affiliate = modal.affiliate || {};

    return (
        <Modal
            open={modal.open}
            width="lg"
            onClose={onClose}
            title="Raise an invoice"
            subtitle="POST /api/invoices/v1 — the publisher comes from the row, the api_key from the brand."
            footer={
                <>
                    <LoadingButton color="neutral" icon={Shuffle} text="New numbers" onClick={onRegenerateIds} />
                    <LoadingButton color="neutral" text="Cancel" onClick={onClose} />
                    <LoadingButton text="Create invoice" loading={loading} loadingText="Creating…" onClick={onSubmit} />
                </>
            }>
            {/* The two values this form never asks for, shown before the call
                goes out so an invoice is never raised against the wrong
                publisher or signed with the wrong brand's key. */}
            <div className="mb-4 rounded-lg border border-gray-200 bg-light/60 p-3 text-xs">
                <div className="flex gap-2">
                    <span className="w-24 shrink-0 text-muted">holder_id</span>
                    <code className="truncate text-gray-700">{affiliate._id || "—"}</code>
                    <span className="truncate text-muted">{affiliate.holder_name || affiliate.email}</span>
                </div>
                <div className="mt-1 flex gap-2">
                    <span className="w-24 shrink-0 text-muted">api_key</span>
                    <code className="truncate text-gray-700">{brand?.api_key || "—"}</code>
                    <span className="truncate text-muted">{brand?.name}</span>
                </div>
            </div>

            <form
                className="grid gap-x-4 sm:grid-cols-2"
                onSubmit={(event) => {
                    event.preventDefault();
                    onSubmit();
                }}>
                <InputField control={control} errors={errors} name="invoice_number" id="invoice-number" label="Invoice number" placeholder="INV-HUL-180" required />
                <InputField control={control} errors={errors} name="ext_invoice_id" id="invoice-ext-id" label="External invoice id" desc="The billing system's own id for this invoice" required />
                <InputField control={control} errors={errors} name="payout_period" id="invoice-period" label="Payout period" placeholder="2026-27" required />
                <SelectField control={control} errors={errors} name="currency" label="Currency" options={CURRENCY_OPTIONS} required />
                <InputField control={control} errors={errors} name="amount" id="invoice-amount" type="number" label="Amount" desc="What the publisher is paid — not derived from the three below" required />
                <InputField control={control} errors={errors} name="subtotal" id="invoice-subtotal" type="number" label="Subtotal" required />
                <InputField control={control} errors={errors} name="fee" id="invoice-fee" type="number" label="Fee" required />
                <InputField control={control} errors={errors} name="tax" id="invoice-tax" type="number" label="Tax" required />
                <InputField control={control} errors={errors} name="issue_date" id="invoice-issue-date" type="date" label="Issue date" required />
                <InputField control={control} errors={errors} name="due_date" id="invoice-due-date" type="date" label="Due date" required />
                <InputField className="sm:col-span-2 mb-1" control={control} errors={errors} name="description" id="invoice-description" label="Description" placeholder="Nov 2026 affiliate payout" />
            </form>
        </Modal>
    );
};

export default InvoiceCreateModal;
